import {K_WINN_URL} from "../../config/constants";
import { postRequest } from '../API'
const API_K_WINN_URL = process.env.REACT_APP_API_BASE_URL
const ANALYSER_URL = process.env.REACT_APP_ANALYSER_URL
/*********************************************************
* Function Name : userList
* Description   : Get list of users list
* By            : Afsar Ali
* Date          : 12-11-2024 
*********************************************************/
export const campaignList = async (options) =>{
    try {
        const params = {
            url : `${API_K_WINN_URL}./crm/analyser/campaign-list`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : getOrderReports
* Description   : 
* By            : Afsar Ali
* Date          : 12-11-2024 
*********************************************************/
export const getOrderReports = async (options) =>{
    try {
        const params = {
            url : `${API_K_WINN_URL}./crm/analyser/order-reports`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : analyzeWinnersList
* Description   : 
* By            : Afsar Ali
* Date          : 12-11-2024 
*********************************************************/
export const analyzeWinnersList = async (options) =>{
    try {
        const params = {
            url : `${ANALYSER_URL}./v1/admin/analyzer/test-matching`,
            postData : options
        }
        const res = await postRequest(params);
        const fixedString = res.data.replace(',', '');
        if(res.status === true || res.status === 200){
            return {status : true, result : {finaldata : JSON.parse(fixedString).flat()}};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : analizeWinners
* Description   : 
* By            : Afsar Ali
* Date          : 12-11-2024 
*********************************************************/
export const analizeWinners = async (options) =>{
    try {
        const params = {
            url : `${ANALYSER_URL}./v1/admin/analyzer/list`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : createWinners
* Description   : 
* By            : Afsar Ali
* Date          : 12-11-2024 
*********************************************************/
export const createWinners = async (options) =>{
    try {
        const params = {
            url : `${API_K_WINN_URL}./crm/analyser/create-winners`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:error?.response?.data?.statusMessage || "Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : getGeneralData
* Description   : Get list of users list
* By            : Afsar Ali
* Date          : 19-05-2025 
*********************************************************/
export const getGeneralData = async (options) =>{
    try {
        const params = {
            url : `${API_K_WINN_URL}./crm/analyser/general-data`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function
